const zg_opt = [
    {label: '全部符合要求', value: '全部符合要求'},
    {label: '全部不符合要求', value: '全部不符合要求'},
    {label: '位置1符合要求', value: '位置1符合要求'},
    {label: '位置1不符合要求', value: '位置1不符合要求'},
    {label: '位置2符合要求', value: '位置2符合要求'},
    {label: '位置2不符合要求', value: '位置2不符合要求'},
    {label: '位置3符合要求', value: '位置3符合要求'},
    {label: '位置3不符合要求', value: '位置3不符合要求'},
    {label: '位置4符合要求', value: '位置4符合要求'},
    {label: '位置4不符合要求', value: '位置4不符合要求'},
]

export default zg_opt
